exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-align[data-v-38599a34] {\n  text-align: center;\n}\n.span-break-minutes[data-v-38599a34] {\n  width: 30px;\n  display: inline-block;\n  text-align: center;\n  font-weight: bold;\n}\n.search-textbox[data-v-38599a34] {\n  width: 30px;\n}\n.break-btn-icon[data-v-38599a34] {\n  margin-left: 3px;\n  margin-right: 3px;\n}\n", ""]);

// exports
